// extracted by mini-css-extract-plugin
module.exports = {"navPill":"NavPill_navPill__13nqk","active":"NavPill_active__1YnpA","navPillShort":"NavPill_navPillShort__2Ri9b"};